export const siteInfo = {
  name: "91网",
  tagline: "资源整合 · 服务导航 · 一站直达",
  description: "91网是您的首选平台，提供全面的资源整合与服务入口。汇聚海量优质资源，打造便捷高效的一站式服务平台。",
  keywords: "91网,91网官方入口,91网注册登录,91网会员权益,91网使用指南,91网资源整合,91网常见问题",
  url: "https://sddiweite.cn",
  email: "service@91wang.com",
  phone: "400-888-9191",
  address: "北京市朝阳区建国路88号SOHO现代城A座18层",
  icp: "京ICP备2024091001号",
  foundingYear: 2015,
};

export const memberBenefits = [
  {
    id: 1,
    title: "海量资源畅享",
    description: "会员可无限访问平台全部资源库，涵盖设计素材、办公模板、技术文档、行业报告等数十万份精选资源。",
    icon: "ri-database-2-line",
  },
  {
    id: 2,
    title: "优先下载特权",
    description: "会员享受高速下载通道，带宽不限速，大批量资源一键打包下载，大幅提升工作效率。",
    icon: "ri-download-cloud-2-line",
  },
  {
    id: 3,
    title: "专属技术支持",
    description: "VIP会员专享7×24小时技术专家在线支持，问题快速响应，复杂需求提供一对一远程协助。",
    icon: "ri-customer-service-2-line",
  },
  {
    id: 4,
    title: "每日更新推送",
    description: "根据您的兴趣偏好，每日智能推送最新优质资源，让您第一时间获取行业前沿内容。",
    icon: "ri-notification-3-line",
  },
  {
    id: 5,
    title: "社区专属权益",
    description: "加入VIP专属社群，与行业大咖交流互动，参与线上线下主题活动，拓展人脉圈层。",
    icon: "ri-team-line",
  },
  {
    id: 6,
    title: "商业授权保障",
    description: "会员下载资源均附赠商业使用授权，放心用于商业项目，免除版权纠纷后顾之忧。",
    icon: "ri-shield-check-line",
  },
];

export const coreFeatures = [
  {
    id: 1,
    title: "资源整合导航",
    description: "整合全网优质资源入口，分类清晰、检索便捷，让您快速找到所需内容。",
    icon: "ri-compass-3-line",
  },
  {
    id: 2,
    title: "智能推荐引擎",
    description: "基于AI算法的个性化推荐系统，根据您的使用习惯精准匹配最合适的资源。",
    icon: "ri-brain-line",
  },
  {
    id: 3,
    title: "安全下载保障",
    description: "所有资源经过多重安全检测，确保无毒无害，让您下载无忧。",
    icon: "ri-shield-flash-line",
  },
  {
    id: 4,
    title: "多端同步服务",
    description: "支持PC、手机、平板多终端无缝同步，随时随地访问您的资源库。",
    icon: "ri-device-line",
  },
];

export const stats = [
  { value: "500万+", label: "注册用户" },
  { value: "30万+", label: "资源总数" },
  { value: "50+", label: "资源分类" },
  { value: "99.9%", label: "服务可用率" },
];

export const brandMilestones = [
  { year: "2015", title: "平台创立", description: "91网正式上线，以资源聚合为核心理念，开启互联网资源服务新篇章。" },
  { year: "2017", title: "用户突破百万", description: "注册用户突破100万，成为国内领先的资源整合服务平台之一。" },
  { year: "2019", title: "会员体系上线", description: "推出VIP会员服务，为用户提供更专业、更全面的资源获取体验。" },
  { year: "2021", title: "AI智能推荐", description: "引入人工智能推荐引擎，实现个性化资源推送，用户体验大幅提升。" },
  { year: "2023", title: "生态全面升级", description: "构建完整的资源生态体系，涵盖工具、教程、资讯、社区等多元服务。" },
  { year: "2025", title: "全球用户500万+", description: "平台注册用户突破500万，服务覆盖海内外，持续引领行业创新发展。" },
];

export const brandValues = [
  { title: "专业", description: "汇聚行业顶尖资源，由专业团队严格筛选和审核，确保每份资源的品质与价值。", icon: "ri-medal-line" },
  { title: "高效", description: "极速检索、一键下载、智能推荐，让资源获取变得前所未有的便捷高效。", icon: "ri-flashlight-line" },
  { title: "安全", description: "多重安全检测机制，严格的内容审核流程，为用户打造安全可靠的资源下载环境。", icon: "ri-shield-user-line" },
  { title: "创新", description: "持续投入技术研发，深度融合AI与大数据技术，不断探索资源服务的新边界。", icon: "ri-lightbulb-flash-line" },
];

export const contactInfo = {
  phone: "400-888-9191",
  email: "service@91wang.com",
  address: "北京市朝阳区建国路88号SOHO现代城A座18层",
  workHours: "周一至周五 9:00 - 18:00",
  wechat: "91wang_service",
  qq: "800091910",
};